export const PROFILE_FORM = 'editProfileForm';
export const PORTFOLIO_FORM = 'portfolioEntryForm';

export const PRIMARY_LANG_REQUIRED_MSG = 'Please enter a primary language';
export const NEED_SPECIALIZATION_MSG = 'Please enter at least one specialization';

export const IMAGE_ENTRIES_RESOURCE_NAME = 'image_entries';

export const NAME_ENTRIES_RESOURCE_NAME = 'name_entries';



// WEBPACK FOOTER //
// ./profile/constants.js